/* eslint-disable camelcase,no-console */
import { Enum, TelemetryLocation } from "@teaming/common-enums";

const ALL_PLACES = Object.create( Enum );
ALL_PLACES.GOAL_SCREEN = TelemetryLocation.GOAL_SCREEN;
ALL_PLACES.IN_MEETING = TelemetryLocation.IN_MEETING;
ALL_PLACES.TEAM_SPACES = TelemetryLocation.TEAM_SPACES;
ALL_PLACES.ONE_ON_ONE_SPACES = TelemetryLocation.ONE_ON_ONE_SPACES;

const QUICK_EDIT_PLACES = Object.create( Enum );
QUICK_EDIT_PLACES.GOAL_SCREEN = TelemetryLocation.GOAL_SCREEN;
QUICK_EDIT_PLACES.IN_MEETING = TelemetryLocation.IN_MEETING;
QUICK_EDIT_PLACES.TEAM_SPACES = TelemetryLocation.TEAM_SPACES;

// eslint-disable-next-line no-unused-vars
export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		goalCreated( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Created", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		goalUpdated( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Updated", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		goalDeleted( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Deleted", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		goalArchived( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Archived", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		goalUnarchived( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Unarchive", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		keyResultAdded( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Key Result Added", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		keyResultUpdated( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Key Result Updated", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		keyResultDeleted( { teamName, teamType, location, } ) {
			if ( !ALL_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Key Result Deleted", {
				team_name: teamName,
				team_type: teamType,
				location,
			} );
		},
		// TODO: call when goals, meetings, and/or team spaces have been migrated
		keyResultMeasureUpdated( { teamName, location, } ) {
			if ( !QUICK_EDIT_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Key Result Measure Updated", {
				team_name: teamName,
				location,
			} );
		},
		// TODO: call when goals, meetings, and/or team spaces have been migrated
		goalConfidenceUpdated( { teamName, location, } ) {
			if ( !QUICK_EDIT_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Goal Confidence Updated", {
				team_name: teamName,
				location,
			} );
		},
		// TODO: call when goals, meetings, and/or team spaces have been migrated
		keyResultConfidenceUpdated( { teamName, location, } ) {
			if ( !QUICK_EDIT_PLACES.includes( location ) ) {
				return console.error( `invalid telemetry location: ${ location }` );
			}
			amplitude.event( "Key Result Confidence Updated", {
				team_name: teamName,
				location,
			} );
		},
	};
};
